module.exports = __webpack_public_path__ + "media/r_ritter1.0.df221bed.mp3";